import { t } from '../features/i18n/index.js';
import { calendarPaymentDate } from '../domain/bank-calendar.js';
import { initRecalculationList } from './recalculation-list.js';

/** Localises the calendar controls and keeps hidden controls out of keyboard navigation. */
export function initBankCalculation(form: HTMLFormElement, onChange: () => void = () => {}): void {
  form.querySelectorAll<HTMLElement>('[data-bank-i18n]').forEach(element => {
    element.textContent = t(element.dataset.bankI18n!);
  });
  form.querySelectorAll<HTMLElement>('[data-bank-i18n-label]').forEach(element => {
    element.setAttribute('aria-label', t(element.dataset.bankI18nLabel!));
  });
  initRecalculationList(form, onChange);
  const fields = form.querySelector<HTMLElement>('#bank-calendar-fields');
  const sync = () => {
    const enabled = form.querySelector<HTMLInputElement>('input[name="calculationMode"]:checked')?.value === 'bank_calendar';
    if (fields) fields.hidden = !enabled;
    const date = form.elements.namedItem('bankDisbursementDate') as HTMLInputElement | null;
    const start = form.elements.namedItem('startDate') as HTMLInputElement | null;
    const day = form.elements.namedItem('bankPaymentDay') as HTMLInputElement | null;
    // A blank or still auto-filled date follows the first payment month and the payment day:
    // a month before the first payment. A date the user typed in is kept.
    const auto = !date?.value || date.value === date.dataset.autoValue;
    if (enabled && date && auto && start?.value) {
      date.value = calendarPaymentDate(start.value, -1, Number(day?.value || 8));
      date.dataset.autoValue = date.value;
    }
  };
  form.querySelectorAll('input[name="calculationMode"]').forEach(input => input.addEventListener('change', sync));
  ['startDate', 'bankPaymentDay'].forEach(name => {
    const input = form.elements.namedItem(name);
    if (input instanceof HTMLInputElement) {
      input.addEventListener('input', sync);
      input.addEventListener('change', sync);
    }
  });
  sync();
}
